import AdminPhaseRequests from './AdminPhaseRequests';
export default function AdminFundedRequests() {
  return <AdminPhaseRequests target="funded" title="Funded Phase Requests" subtitle="Phase 2 upgrades (Core & Global) and single-phase completion (Split Fee) requesting the Funded phase." />;
}
